import React from "react";
import SocialMedia from "../../../sections/BusinessDashboard/Settings/SocialMedia";
import { AdminPageTitle } from "../../../sections/AdminDashboard/shared/adminUx";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import { BUSINESS_CENTERED_PAGE_TITLE_CLASS } from "../../../sections/BusinessDashboard/shared/businessLayoutSpec";

const Social = () => {
  return (
    <DashboardMainContainer className="lg:px-5 lg:pb-10">
      <AdminPageTitle className={`text-offblack ${BUSINESS_CENTERED_PAGE_TITLE_CLASS}`}>
        Social profiles
      </AdminPageTitle>
      <div className="min-h-screen">
        <SocialMedia />
      </div>
    </DashboardMainContainer>
  );
};

export default Social;
